import { Trans } from "@lingui/macro";
import { Box, Typography, Button } from "@mui/material";

function DeleteWorkoutProfileDrawer({
  profileName,
  handleCloseDrawer,
  handleDelete,
}: {
  profileName?: string;
  handleCloseDrawer: () => void;
  handleDelete: () => void;
}) {
  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="column" gap={1} alignItems="center" px={4} pb={3} pt={4}>
        <Typography variant="prose-lg-medium" textAlign="center">
          <Trans>Delete &quot;{profileName}&quot;</Trans>
        </Typography>
        <Typography variant="prose-base" textAlign="center">
          <Trans>
            Are you sure you want to delete this workout profile? This action cannot be undone.
          </Trans>
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row" p={3} gap={1.5}>
        <Button variant="outlined" size="large" fullWidth onClick={handleCloseDrawer}>
          <Trans>Keep</Trans>
        </Button>
        <Button color="error" variant="outlined" size="large" fullWidth onClick={handleDelete}>
          <Trans>Delete</Trans>
        </Button>
      </Box>
    </Box>
  );
}

export default DeleteWorkoutProfileDrawer;
